module.exports = __webpack_public_path__ + "static/media/savio18.9eba5edb.jpg";